import { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const IconAwesome: React.FC<{ processIcon: string }> = ({ processIcon }) => {
    const icon = require('@fortawesome/free-solid-svg-icons')[processIcon];
    return <FontAwesomeIcon icon={icon} />;
  };

export default memo(IconAwesome);